import { ThemeProvider, ToastProvider } from '@hopex/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { registerWorker } from './lib/platform.ts';
import './styles.css';

// After a deploy an open app may ask for a code piece that no longer exists: reload once (≤ 1 / 30 s).
window.addEventListener('vite:preloadError', (e) => {
  try {
    const last = Number(window.sessionStorage.getItem('dk-reloaded-at') ?? '0');
    if (Date.now() - last < 30_000) return;
    window.sessionStorage.setItem('dk-reloaded-at', String(Date.now()));
  } catch {
    return;
  }
  e.preventDefault();
  window.location.reload();
});

void registerWorker();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
